var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---Payment-Tasks---Desktop",
    transform: "translate(-397.000000, -1450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(380.000000, 1324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment/Task/Mobile-Copy-9",
    transform: "translate(1.000000, 111.000000)",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Edit-circle-Copy",
    transform: "translate(16.000000, 15.703704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-regular",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6,19 C17.80625,19 16.94375,20 14,20 C11.05625,20 10.2,19 8.4,19 C3.7625,19 0,22.7625 0,27.4 L0,29 C0,30.65625 1.34375,32 3,32 L25,32 C26.65625,32 28,30.65625 28,29 L28,27.4 C28,22.7625 24.2375,19 19.6,19 Z M25,29 L3,29 L3,27.4 C3,24.425 5.425,22 8.4,22 C9.3125,22 10.79375,23 14,23 C17.23125,23 18.68125,22 19.6,22 C22.575,22 25,24.425 25,27.4 L25,29 Z M14,18 C18.96875,18 23,13.96875 23,9 C23,4.03125 18.96875,0 14,0 C9.03125,0 5,4.03125 5,9 C5,13.96875 9.03125,18 14,18 Z M14,3 C17.30625,3 20,5.69375 20,9 C20,12.30625 17.30625,15 14,15 C10.69375,15 8,12.30625 8,9 C8,5.69375 10.69375,3 14,3 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.74bd978dbe3cb18b0ccb5299f65c0c62.svg";
export { ForwardRef as ReactComponent };